import script from "./ProcedureFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcedureFooter.vue?vue&type=script&setup=true&lang=js"

import "./ProcedureFooter.vue?vue&type=style&index=0&id=6b0478c7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b0478c7"]])

export default __exports__